import { Link } from "react-router-dom";

export function Btn({ variant = "primary", className = "", as, to, ...props }) {
  const base = "inline-flex items-center justify-center gap-2 rounded-full font-medium transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-black disabled:opacity-40 disabled:pointer-events-none";
  const variants = {
    primary: "bg-[#D5E5F9] text-[#292827] hover:bg-[#BCD6F4] px-6 py-3 text-[15px]",
    secondary: "bg-white text-[#292827] border border-[#292827] hover:bg-[#292827] hover:text-white px-6 py-3 text-[15px]",
    outline: "bg-white text-[#292827] border border-[#E6E1D9] hover:border-[#292827] px-6 py-3 text-[15px]",
    ghost: "bg-transparent text-[#292827] hover:bg-[#E9EAEC] px-4 py-2.5 text-[15px]",
    dark: "bg-[#292827] text-white hover:bg-[#1c1b1a] px-6 py-3 text-[15px]",
    accent: "bg-[#292827] text-white hover:bg-[#1c1b1a] px-6 py-3 text-[15px]",
    pink: "bg-white text-[#292827] border border-[#292827] hover:bg-[#292827] hover:text-white px-6 py-3 text-[15px]",
    sm: "bg-[#D5E5F9] text-[#292827] hover:bg-[#BCD6F4] px-4 py-2 text-sm",
    bare: "px-6 py-3 text-[15px]",
  };
  const cls = `${base} ${variants[variant] || variants.primary} ${className}`;
  if (to) return <Link to={to} className={cls} {...props} />;
  const Comp = as || "button";
  return <Comp className={cls} {...props} />;
}

export function Card({ className = "", children, ...props }) {
  return (
    <div className={`bg-white rounded-2xl border border-[#E6E1D9] ${className}`} {...props}>
      {children}
    </div>
  );
}

export function Field({ label, className = "", ...props }) {
  return (
    <label className="block">
      {label && <span className="block text-[13px] font-medium text-[#292827] mb-2">{label}</span>}
      <input
        className={`w-full rounded-xl bg-white border border-[#E6E1D9] px-4 py-3.5 text-[15px] text-[#292827] outline-none focus:border-[#292827] transition-colors placeholder:text-[#968F85] ${className}`}
        {...props}
      />
    </label>
  );
}

export function TextArea({ label, className = "", ...props }) {
  return (
    <label className="block">
      {label && <span className="block text-[13px] font-medium text-[#292827] mb-2">{label}</span>}
      <textarea
        className={`w-full rounded-xl bg-white border border-[#E6E1D9] px-4 py-3.5 text-[15px] text-[#292827] outline-none focus:border-[#292827] transition-colors min-h-[130px] placeholder:text-[#968F85] ${className}`}
        {...props}
      />
    </label>
  );
}

const STATUS = {
  open: { t: "Avoin", dot: "bg-emerald-500", c: "text-[#292827] border-[#E6E1D9]" },
  closed: { t: "Suljettu", dot: "bg-[#B7B0A5]", c: "text-[#6E675C] border-[#E6E1D9]" },
  draft: { t: "Luonnos", dot: "bg-[#B7B0A5]", c: "text-[#6E675C] border-[#E6E1D9]" },
  expired: { t: "Hakuaika päättynyt", dot: "bg-[#B7B0A5]", c: "text-[#6E675C] border-[#E6E1D9]" },
  pending: { t: "Odottaa", dot: "bg-amber-400", c: "text-[#292827] border-[#E6E1D9]" },
  accepted: { t: "Hyväksytty", dot: "bg-emerald-500", c: "text-[#292827] border-[#E6E1D9]" },
  rejected: { t: "Hylätty", dot: "bg-[#B7B0A5]", c: "text-[#6E675C] border-[#E6E1D9]" },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] || { t: status, dot: "bg-[#B7B0A5]", c: "text-[#6E675C] border-[#E6E1D9]" };
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.c}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} /> {s.t}
    </span>
  );
}

export function Tag({ children }) {
  return <span className="inline-flex items-center rounded-full border border-[#E6E1D9] bg-white px-2.5 py-1 text-xs font-medium text-[#292827]">{children}</span>;
}

export function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F3F0]">
      <div className="h-7 w-7 rounded-full border-2 border-[#E6E1D9] border-t-[#292827] animate-spin" />
    </div>
  );
}
